import React from "react"
import PropTypes from "prop-types"

// conditionally render classNames
import classNames from "classnames"

// component for onHover
import Tooltip from "components/Tooltip"

// type Props = {
//     // from search-new/components/Inline/LongInlinePresentation.js
//     options: Object,
// };

/** if an Inline has option button selectors, display them */
const InlineOptions = (props) => (
    <div className={classNames("inline-options-wrapper", { "is-searchify is-searchify-selected": props.isSelected })}>
        {props.options
            .filter((option) => option.display !== false)
            .map((option) => (
                <div className={classNames("inline-option", option.style_class)} key={option.icon}>
                    {option.icon && <i className={`fa fa-lg ${option.icon}`} />}
                    {option.text && <div className="inline-clear-text">{option.text}</div>}
                    {
                        // we are using the <object> tag as a markup-validating container for nested links
                        // http://kizu.ru/en/fun/nested-links/
                        <object type="segue">
                            <Tooltip label={option.tip_text}>
                                <a
                                    {...(option.dataCy ? { "data-cy": option.dataCy } : {})}
                                    id={option.parentId}
                                    href={option.href}
                                    data-toggle="tooltip"
                                    data-placement="top auto"
                                    onClick={(e) => option.callback(e)}
                                >
                                    {}
                                </a>
                            </Tooltip>
                        </object>
                    }
                </div>
            ))}
    </div>
)

InlineOptions.propTypes = {
    // from search-new/components/Inline/LongInlinePresentation.js or
    // search-new/components/Inline/CommitteeHearingInlinePresentation.js
    isSelected: PropTypes.bool,
    // from search-new/components/Inline/LongInlinePresentation.js
    options: PropTypes.arrayOf(PropTypes.object),
}

export default InlineOptions
